import moment from "moment";
export const SERVER_TIME_ZONE = 'America/Los_Angeles';

export function getPSTTimeNow() {
  // Get the current date and time in the 'America/Los_Angeles' timezone
  const pstTimeString = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(new Date());

  // Convert the PST formatted string back into a Date object if needed
  const pstDate = new Date(pstTimeString);

  return pstDate;
}

export const getSeccondsDiff = (endDate, startDate = moment()) => {
  const _startDate = moment(startDate);
  let _endDate = moment(endDate);

  if (!moment(_endDate).isValid() || !moment(_startDate).isValid()) {
    return undefined;
  }

  return moment(_endDate).diff(_startDate, 'seconds');
};

export const formatSecondsCountdown = (seconds) => {
  const SECONDS_IN_HOUR = 3600;
  const days = Math.floor(seconds / (24 * SECONDS_IN_HOUR));
  const remainingSecondsAfterDays = seconds % (24 * SECONDS_IN_HOUR);
  const hours = Math.floor(remainingSecondsAfterDays / SECONDS_IN_HOUR);
  const minutes = Math.floor((remainingSecondsAfterDays % SECONDS_IN_HOUR) / 60);
  const remainingSeconds = remainingSecondsAfterDays % 60;

  const daysStr = days > 0 ? `${days}d ` : '';
  const hoursStr = hours > 0 || days > 0 ? `${hours.toString().padStart(2, '0')}:` : '';
  const minutesStr = `${minutes.toString().padStart(2, '0')}:`;
  const secondsStr = remainingSeconds.toString().padStart(2, '0');

  return `${daysStr}${hoursStr}${minutesStr}${secondsStr}`.trim();
};

export const isBeforeDate =  (dateOne , dateTwo) => {
  return  moment(dateOne).isBefore(dateTwo);
};


// WEBPACK FOOTER //
// ./src/utils/dateHelper.js